
import Vue from "vue";
import moment from "moment";
import { UserMood } from "@prestonly/preston-common";
import { UserStats } from "@/store/modules/user";
import FireIcon from "@/components/base/FireIcon.vue";
import FrozenFireIcon from "@/components/base/FrozenFireIcon.vue";
import { FireState } from "@/types/streak";

type CalendarItem = {
  date: Date;
  submittedMood: UserMood | null;
  isCurrentDate: boolean;
  // Part of the streak chain: a day with activity or a day a freeze covered.
  isStreakDay: boolean;
  isActiveDay: boolean;
  isFrozenDay: boolean;
};

export default Vue.extend({
  name: "DashboardMobileMoodCalendar",
  components: {
    FireIcon,
    FrozenFireIcon,
  },
  data: () => ({
    isLoading: true,
    FireState,
  }),
  computed: {
    moods(): UserMood[] {
      return this.$store.getters["user/getMoods"];
    },
    moodsMap(): Map<string, UserMood> {
      const map = new Map();
      this.moods.forEach((mood) => {
        map.set(moment(mood.date).format("YYYY-MM-DD"), mood);
      });
      return map;
    },

    stats(): UserStats {
      return this.$store.getters["user/getStats"];
    },

    statsMap(): Map<string, number> {
      const map = new Map();
      this.stats.dailyCorrectAnswers.forEach((stat) => map.set(stat.date, stat.count));

      return map;
    },
    frozenDays(): Set<string> {
      return new Set(this.stats.frozenDays || []);
    },
    days(): CalendarItem[] {
      const count = 90;
      const days: CalendarItem[] = [];
      for (let i = 0; i < count; i++) {
        const date = moment().subtract(i, "days");
        const mood = this.moodsMap.get(date.format("YYYY-MM-DD")) || null;
        const isActiveDay = this.getDailyCorrectAnswers(date.toDate()) > 0;
        const isFrozenDay = !isActiveDay && this.frozenDays.has(date.format("YYYY-MM-DD"));
        days.push({
          date: date.toDate(),
          submittedMood: mood,
          isCurrentDate: date.isSame(moment(), "day"),
          isStreakDay: isActiveDay || isFrozenDay,
          isActiveDay,
          isFrozenDay,
        });
      }
      return days;
    },
  },
  mounted() {
    const container = document.querySelector(".dashboard-mobile-mood-calendar");
    if (container) {
      container.scrollLeft = 0;
    }
  },
  methods: {
    getDailyCorrectAnswers(date: Date): number | string {
      const dateFormat = moment(date).format("YYYY-MM-DD");
      return this.statsMap.get(dateFormat) || "-";
    },

    isDailyIcon(date: Date): boolean {
      const dateFormat = moment(date).format("YYYY-MM-DD");
      return this.statsMap.has(dateFormat) && this.statsMap.get(dateFormat) > 0;
    },
  },
});
